/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { ListingStatus } from '../enums/ListingStatus'

export const isActive = (
  status: ListingStatus
): status is ListingStatus.ACTIVE | ListingStatus.PENDING | ListingStatus.DUPLICATE =>
  status === ListingStatus.ACTIVE ||
  status === ListingStatus.PENDING ||
  status === ListingStatus.DUPLICATE
export const isBlocked = (
  status: ListingStatus
): status is ListingStatus.BANNED | ListingStatus.SPAM =>
  status === ListingStatus.BANNED || status === ListingStatus.SPAM
export const isInvalid = (
  status: ListingStatus
): status is
  | ListingStatus.DRAFT
  | ListingStatus.ACTIVE
  | ListingStatus.PENDING
  | ListingStatus.BANNED
  | ListingStatus.SPAM =>
  status === ListingStatus.DRAFT ||
  status === ListingStatus.ACTIVE ||
  status === ListingStatus.PENDING ||
  status === ListingStatus.BANNED ||
  status === ListingStatus.SPAM
export const isDeleted = (status: ListingStatus): status is ListingStatus.DELETED =>
  status === ListingStatus.DELETED
export const isForSale = (status: ListingStatus): status is ListingStatus.FOR_SALE =>
  status === ListingStatus.FOR_SALE
export const isHoneypot = (status: ListingStatus): status is ListingStatus.HONEYPOT =>
  status === ListingStatus.HONEYPOT
export const isPrivateOrPending = (
  status: ListingStatus
): status is ListingStatus.PRIVATE | ListingStatus.PENDING =>
  status === ListingStatus.PENDING || status === ListingStatus.PRIVATE
